import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";

const PrimaryButton = (props) => {
  const classes = useStyles();

  return (
    <Button
      disableRipple
      className={classes.primaryButton}
      {...props}
    >
      {props.children}
    </Button>
  );
};

export default PrimaryButton;

const useStyles = makeStyles((theme) => ({
  primaryButton: {
    color: "var(--White)",
    backgroundColor: "var(--teal-600)",
    transition: "background-color 0.2s ease-out",
    fontWeight: "normal",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "var(--teal-700)",
      transition: "background-color 0.2s ease-out",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      color: "var(--White)",
    },
    "&:active": {
      backgroundColor: "var(--teal-800)",
    },
    "&:focus": {
      backgroundColor: "var(--teal-600)",
      outline: "1px solid var(--teal-600)",
      outlineOffset: "4px",
    },
  },
}));
